import StoppedCampaign from "./StoppedCampaign";

export default StoppedCampaign;
